/**
 * @file Form Controller
 */

'use strict';
import Listener from '../Utils/Listener';
import FormModel from '../Model/FormModel';
import ApplyClass from '../Utils/ApplyClass';
import Validate from '../View/Form/Validate';
import BtnAdd from '../View/Form/BtnAdd';
import BtnDelete from "../View/Form/BtnDelete";
import Select2 from '../View/Form/Select2';
import Common from '../Utils/Common';
import DatePicker from '../View/Form/DatePicker';
import CalculatePaidMutualAid from '../View/Form/CalculatePaidMutualAid';
import SetCurrentIndexToModal from '../View/Form/SetCurrentIndexToModal';
import CheckAll from '../View/Form/CheckAll';
import CheckboxEmpty from '../View/Form/CheckboxEmpty';
import CheckAllCheckbox from '../View/Form/CheckAllCheckbox';
import ChangeDisplayByRadioButton from '../View/Form/ChangeDisplayByRadioButton';
import ChangeSupportingDen from '../View/Form/ChangeSupportingDen';
import ChangeSupportingScout from '../View/Form/ChangeSupportingScout';
import ChangeSupporterRegisteredAt from '../View/Form/ChangeSupporterRegisteredAt';
import ZenkakuToHankaku from '../View/Form/ZenkakuToHankaku';
import ChangeContributionType from '../View/Form/ChangeContributionType';
let instance = null;

/**
 * @classname Form
 * @classdesc Form Controller
 */
export default class Form {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}
		console.log('Form.constructor');

		this._model = new FormModel();

		this._listener = new Listener();
		this._$form = null;
		this._submit = true;

		this._model.on('getOperatorsComplete', () => {
			this._operators = this._model._data.result;
			this.onCompleteGetOperators();
		})
		this._model.on('getDistrictsComplete', () => {
			this._districts = this._model._data;
			this._listener.trigger('getDistrictsComplete');
		})
		this._model.on('getDistrictsAffiliationsComplete', () => {
			this._districts = this._model._data.districts;
			this._affiliations = this._model._data.affiliations;
			this._listener.trigger('getDistrictsAffiliationsComplete');
		})
		this._model.on('getGroupsComplete', () => {
			this._groups = this._model._data;
			this._listener.trigger('getGroupsComplete');
		})
		this._model.on('getGroupsAffiliationsComplete', () => {
			this._groups = this._model._data.groups;
			this._affiliations = this._model._data.affiliations;
			this._listener.trigger('getGroupsAffiliationsComplete');
		})
		this._model.on('getGroupsFromCouncilComplete', () => {
			this._groups = this._model._data;
			this._listener.trigger('getGroupsFromCouncilComplete');
		})
		this._model.on('getGroupsAffiliationsFromCouncilComplete', () => {
			this._groups = this._model._data.groups;
			this._affiliations = this._model._data.affiliations;
			this._listener.trigger('getGroupsAffiliationsFromCouncilComplete');
		})
		this._model.on('getDistrictsGroupsComplete', () => {
			this._districts = this._model._data.districts;
			this._groups = this._model._data.groups;
			this._listener.trigger('getDistrictsGroupsComplete');
		})
		this._model.on('getDistrictsGroupsAffiliationsComplete', () => {
			this._districts = this._model._data.districts;
			this._groups = this._model._data.groups;
			this._affiliations = this._model._data.affiliations;
			this._listener.trigger('getDistrictsGroupsAffiliationsComplete');
		})
		this._model.on('getAffiliationsComplete', () => {
			this._affiliations = this._model._data;
			this._listener.trigger('getAffiliationsComplete');
		})
		this._model.on('getTitlesComplete', () => {
			this._titles = this._model._data;
			this._listener.trigger('getTitlesComplete');
		})
		this._model.on('linkDataComplete', () => {
			this._listener.trigger('linkDataComplete');
		})
		this._model.on('getMemberDataComplete', () => {
			this._memberData = this._model._data;
			this._listener.trigger('getMemberDataComplete');
		})
		this._model.on('searchMemberComplete', () => {
			this._memberCount = this._model._data.member_count
			this._members = this._model._data.members;
			this._listener.trigger('searchMemberComplete');
		})
		this._model.on('commonSearchMemberComplete', () => {
			this._memberCount = this._model._data.member_count
			this._members = this._model._data.members;
			this._listener.trigger('commonSearchMemberComplete');
		})
		this._model.on('getMemberDataFromMemberSearchModalComplete', () => {
			this._selectedMember = this._model._data
			this._listener.trigger('getMemberDataFromMemberSearchModalComplete');
		})
		this._model.on('getGroupCommitteeChairmanComplete', () => {
			this._groupCommitteeChairman = this._model._data;
			this._listener.trigger('getGroupCommitteeChairmanComplete');
		})
		this._model.on('registerSupporterComplete', () => {
			this._registerSupporterData = this._model._data;
			this._listener.trigger('registerSupporterComplete');
		})
		this._model.on('getTransferTargetComplete', () => {
			this._transferMemberData = this._model._data;
			this._listener.trigger('getTransferTargetComplete');
		})
		this._model.on('getAdditionalTitleTargetComplete', () => {
			this._additionalTitleMemberData = this._model._data;
			this._listener.trigger('getAdditionalTitleTargetComplete');
		})
		this._model.on('groupEasySearchComplete', () => {
			this._data = this._model._data;
			this._listener.trigger('groupEasySearchComplete');
		})
		this._model.on('groupEasySearch2Complete', () => {
			this._data = this._model._data;
			this._listener.trigger('groupEasySearch2Complete');
		})
		this._model.on('onGetEasySearchDistrictsGroupsComplete', () => {
			this._data = this._model._data;
			this._listener.trigger('onGetEasySearchDistrictsGroupsComplete');
		})
		this._model.on('onSetTmpPasswordComplete', () => {
			this._listener.trigger('onSetTmpPasswordComplete');
		})
		this.recalculateContributionPrice()
		instance = this;
		return instance;
	};


	/**
	 * 前処理終了
	 *
	 * 同ページ内で複数formに .check-all を使用したい場合は
	 * 前処理終了時にこちらの trigger を引く
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completeMultipleCheckAllPreProcessing($form) {
		console.log('Form.completeMultipleCheckAllPreProcessing');
		this._$form = $form;
		this._listener.trigger('completeMultipleCheckAllPreProcessing');
	};


	/**
	 * 前処理終了
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completePreProcessing($form) {
		console.log('Form.completePreProcessing');
		this._$form = $form;
		this._listener.trigger('completePreProcessing');
	};


	/**
	 * バリデーションチェック
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	validate($form) {
		console.log('Form.validate');
		this._$form = $form;
		this._listener.trigger('validate');
		setTimeout(() => {
			this._listener.trigger('completeValidate');
		}, 500);
	};


	/**
	 * バリデーションチェック
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	validateModal($form) {
		console.log('Form.validate');
		this._$form = $form;
		this._listener.trigger('validate');
	};


	/**
	 * 後処理終了
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completePostProcessing($form) {
		console.log('Form.completePostProcessing');
		this._$form = $form;
		this._listener.trigger('completePostProcessing');
	};


	/**
	 * 要素追加ボタンアクティベート
	 *
	 * @memberof Form
	 * @param {object} $addedItem - 追加されたアイテム
	 * @param {object} $base - 追加されたアイテム（兄弟要素含む）
	 * @return {undefined}
	 */
	activateAddedItem($addedItem, $base) {
		console.log('Form.activateAddedItem');
		this._$addedItem = $addedItem;
		this._$baseWrap = $base.parent();
		$addedItem.find('.validate').each((idx, e) => {
			const $e = $(e);
			ApplyClass.apply(Validate, $e, [$e, this]);
		});
		const $btnAdd = $addedItem.find('.btn-add');
		ApplyClass.apply(BtnAdd, $btnAdd, [$btnAdd, this]);
		const $btnDelete = $addedItem.find('.btn-delete');
		ApplyClass.apply(BtnDelete, $btnDelete, [$btnDelete, this]);
		switch (true) {
			case (!!$addedItem.closest('.list-operator').length):
				{
					console.log(`Form.activateAddedItem / closest('.list-operator')`);
					const councilId = $('#council_id').val();
					this._model.getOperators(councilId);
				}
				break;
			case (!!$addedItem.closest('.list-paid-mutual-aid').length):
				{
					console.log(`Form.activateAddedItem / closest('.list-paid-mutual-aid')`);
					const $datepicker = $addedItem.find('[data-datepicker="true"]');
					ApplyClass.apply(DatePicker, $datepicker, [$datepicker, this]);
					this._listener.trigger('total-paid-mutual-aid-calculate');
					$addedItem.find('.paid_mutual_aid_price').each((_, element) => {
						const $element = $(element);
						ApplyClass.apply(CalculatePaidMutualAid, $element, [$element, this]);
					});
					$addedItem.find('.btn-delete').each((_, element) => {
						$(element).on('click', () => this._listener.trigger('total-paid-mutual-aid-calculate'));
					});
					this.reNumbering();
				}
				break;
			case (!!$addedItem.closest('.list-administrational-operator').length):
				{
					console.log(`Form.activateAddedItem / closest('.list-administrational-operator')`);
					const $button = $addedItem.find('[data-bs-target="#modal-common-member-search"]');
					ApplyClass.apply(SetCurrentIndexToModal, $button, [$button, this]);
					const $checkAllCheckbox = $addedItem.find('.check-all-checkbox');
					ApplyClass.apply(CheckAllCheckbox, $checkAllCheckbox, [$checkAllCheckbox, this]);
					const $checkboxes = $addedItem.find('.validate[data-validate="checkboxempty"][name]');
					$checkboxes.each((_, element) => ApplyClass.apply(CheckboxEmpty, $(element), [$(element), this]));
				}
				break;
			case (!!$addedItem.closest('.list-general-operator').length):
				{
					console.log(`Form.activateAddedItem / closest('.list-general-operator')`);
					const $button = $addedItem.find('[data-bs-target="#modal-common-member-search"]');
					ApplyClass.apply(SetCurrentIndexToModal, $button, [$button, this]);
				}
				break;
			case (!!$addedItem.closest('.list-supporter').length):
				{
					console.log(`Form.activateAddedItem / closest('.list-supporter')`);
					const unselectedOptionHtml = `<option value="">選択</option>`
					$addedItem.find('.master_den_ids').append(unselectedOptionHtml)
					this._registerSupporterData.dens.forEach(den => {
						$addedItem.find('.master_den_ids').append(`<option value="${den.id}">${den.name}</option>`)
					})
					$addedItem.find('.scout_member_ids').append(unselectedOptionHtml)
					this._registerSupporterData.scouts.forEach(scout => {
						$addedItem.find('.scout_member_ids').append(`<option value="${scout.id}" data-den-name="${scout.den}">${scout.name}</option>`)
					})
					$addedItem.find('.change-display-group').each((_, element) => ApplyClass.apply(ChangeDisplayByRadioButton, $(element), [$(element), this]));
					$addedItem.find('.select2').each((_, element) => ApplyClass.apply(Select2, $(element), [$(element), this]));
					$addedItem.find('.master_den_ids').each((_, element) => ApplyClass.apply(ChangeSupportingDen, $(element), [$(element), this]));
					$addedItem.find('.scout_member_ids').each((_, element) => ApplyClass.apply(ChangeSupportingScout, $(element), [$(element), this]));
					$addedItem.find('.supporter-registered-at').each((_, element) => ApplyClass.apply(ChangeSupporterRegisteredAt, $(element), [$(element), this]));
				}
				break;
			case (!!$addedItem.closest('.list-councils-to-contribute').length):
				{
					console.log(`Form.activateAddedItem / closest('.list-councils-to-contribute')`);
					this._$baseWrap.find('.renumbering').each((index, element) => $(element).text(index + 1))
					$addedItem.find('.btn-delete').on('click', () => this._$baseWrap.find('.renumbering').each((index, element) => $(element).text(index + 1)))
					$addedItem.find('.zen2han').each((_, element) => ApplyClass.apply(ZenkakuToHankaku, $(element), [$(element), this]));
					$addedItem.find('.contribution_type').each((_, element) => ApplyClass.apply(ChangeContributionType, $(element), [$(element), this]));
					this._$baseWrap
						.find('.list-item:not(.list-item-additional)')
						.find('.specified_purpose_id option')
						.each((_, element) => $addedItem.find('.specified_purpose_id').append($(element).clone().removeAttr('selected')))
				}
				break;
			default:
				this.reNumbering();
		}
	};


	/**
	 * 仮パスワード設定
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	setTmpPassword() {
		console.log(`Form.setTmpPassword`);
		this._listener.trigger('validate');
		setTimeout(() => {
			if (!$('#modal-tmp-password .validate').hasClass('is-invalid')) {
				this._model.setTmpPassword()
			}
		}, 500);
	};


	/**
	 * オペレーターOption取得コールバック
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	onCompleteGetOperators() {
		console.log('Form.onCompleteGetOperators');
		const operators = this._model._data;
		let existedOperators = [];
		// $('.operator_id').each((idx, e) => {
		// 	const $e = $(e);
		// 	if($e.val()) existedOperators.push(parseInt($e.val()));
		// });
		let options = '';
		for (let i = 0; i < operators.length; i++) {
			if (!existedOperators.includes(operators[i].member_id)) {
				options += `<option value="${operators[i].member_id}">${operators[i].name}（${operators[i].member_id}）</option>`
			}
		}
		if (options !== '') {
			const $select2 = this._$addedItem.find('.select2');
			$select2.html(options);
			ApplyClass.apply(Select2, $select2, [$select2, this]);
			this.reNumbering();
		} else {
			this._$addedItem.remove();
			Common.showErrorModal('これ以上操作担当者は追加できません。');
		}
	};


	/**
	 * ナンバリング変更
	 *
	 * @memberof Form
	 * @param {jquery} $baseWrap - 追加・削除されたアイテムの親要素
	 * @return {undefined}
	 */
	reNumbering($baseWrap) {
		console.log('Form.reNumbering');
		this._$baseWrap.children().each((idx, e) => {
			const $e = $(e);
			console.log($e);
			$e.find('.validate').each((index, validate) => {
				const $validate = $(validate);
				const name = $validate.attr('name').replace(/\[\d+/g, `[${idx}`);
				$validate.attr('name', name);
			});
			$e.find('span.mutual-aid-payment-count').each((_, span) => {
				const $span = $(span);
				$(span).text(idx + 1);
			});
		});
	};


	/**
	 * 地区リスト取得
	 *
	 * @memberof Form
	 * @param councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistricts(councilId, dormantFlg) {
		console.log('Form.getDistricts');
		this._model.getDistricts(councilId, dormantFlg);
	};


	/**
	 * かんたん団検索
	 *
	 * @memberof Form
	 * @param {string} groupName - 団名
	 * @return {undefined}
	 */
	groupEasySearch(groupName) {
		console.log('Form.groupEasySearch');
		this._model.groupEasySearch(groupName);
	};


	/**
	 * かんたん団検索2
	 *
	 * @memberof Form
	 * @param {string} groupName - 団名
	 * @return {undefined}
	 */
	groupEasySearch2(groupName) {
		console.log('Form.groupEasySearch2');
		this._model.groupEasySearch2(groupName);
	};


	/**
	 * 地区リスト・所属リスト取得
	 *
	 * @memberof Form
	 * @param councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistrictsAffiliations(councilId, dormantFlg) {
		console.log('Form.getDistrictsAffiliations');
		this._model.getDistrictsAffiliations(councilId, dormantFlg);
	};


	/**
	 * 地区リスト・団リスト取得
	 *
	 * @memberof Form
	 * @param councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistrictsGroups(councilId, dormantFlg) {
		console.log('Form.getDistrictsGroups');
		this._model.getDistrictsGroups(councilId, dormantFlg);
	};


	/**
	 * かんたん団検索
	 *
	 * @memberof Form
	 * @param {string} groupId - 団ID
	 * @return {undefined}
	 */
	getEasySearchDistrictsGroups(groupId) {
		console.log('Form.groupEasySearch');
		this._model.getEasySearchDistrictsGroups(groupId);
	};



	/**
	 * 地区リスト・団リスト・所属リスト取得
	 *
	 * @memberof Form
	 * @param councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getDistrictsGroupsAffiliations(councilId, dormantFlg) {
		console.log('Form.getDistrictsGroupsAffiliations');
		this._model.getDistrictsGroupsAffiliations(councilId, dormantFlg);
	};


	/**
	 * 団リスト取得
	 *
	 * @memberof Form
	 * @param districtId - 地区ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroups(districtId, dormantFlg) {
		console.log('Form.getGroups');
		this._model.getGroups(districtId, dormantFlg);
	};


	/**
	 * 団リスト・所属リスト取得
	 *
	 * @memberof Form
	 * @param districtId - 地区ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroupsAffiliations(districtId, dormantFlg) {
		console.log('Form.getGroupsAffiliations');
		this._model.getGroupsAffiliations(districtId, dormantFlg);
	};


	/**
	 * 団リスト取得（連盟変更時）
	 *
	 * @memberof Form
	 * @param councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroupsFromCouncil(councilId, dormantFlg) {
		console.log('Form.getGroupsFromCouncil');
		this._model.getGroupsFromCouncil(councilId, dormantFlg);
	};


	/**
	 * 団リスト・所属リスト取得（連盟変更時）
	 *
	 * @memberof Form
	 * @param councilId - 連盟ID
	 * @param dormantFlg - 活動していない組織の情報を取得するか
	 * @return {undefined}
	 */
	getGroupsAffiliationsFromCouncil(councilId, dormantFlg) {
		console.log('Form.getGroupsAffiliationsFromCouncil');
		this._model.getGroupsAffiliationsFromCouncil(councilId, dormantFlg);
	};


	/**
	 * 所属リスト取得
	 *
	 * @memberof Form
	 * @param groupId - 団ID
	 * @return {undefined}
	 */
	getAffiliations(groupId) {
		console.log('Form.getAffiliations');
		this._model.getAffiliations(groupId);
	};


	/**
	 * 従登録用 所属リスト取得
	 *
	 * @memberof Form
	 * @param groupId - 団ID
	 * @return {undefined}
	 */
	getAffiliationsAdditional(groupId) {
		console.log('Form.getAffiliationsAdditional');
		this._model.getAffiliationsAdditional(groupId);
	};


	/**
	 * 役務リスト取得
	 *
	 * @memberof Form
	 * @param AffiliationId - 所属ID
	 * @return {undefined}
	 */
	getTitles(AffiliationId) {
		console.log('Form.getTitles');
		this._model.getTitles(AffiliationId);
	};


	/**
	 * 従登録用 役務リスト取得
	 *
	 * @memberof Form
	 * @param AffiliationId - 所属ID
	 * @return {undefined}
	 */
	getTitlesAdditional(AffiliationId) {
		console.log('Form.getTitlesAdditional');
		this._model.getTitlesAdditional(AffiliationId);
	};


	/**
	 * データ紐付け
	 *
	 * @memberof Form
	 * @param memberId - 加盟員No.
	 * @return {undefined}
	 */
	linkData(memberId) {
		console.log('Form.linkData');
		this._model.linkData(memberId);
	};


	/**
	 * 加盟員Noから会員情報を取得する
	 *
	 * @memberof Form
	 * @param memberId - 加盟員No.
	 * @return {undefined}
	 */
	getMemberData(memberId) {
		console.log(`Form.getMemberData: ${memberId}`);
		this._model.getMemberData(memberId);
	};


	/**
	 * 連盟・地区・団IDから会員情報を取得する
	 *
	 * @memberof Form
	 * @param ids - 連盟・地区・団ID
	 * @return {undefined}
	 */
	getGroupCommitteeChairman(ids) {
		this._model.getGroupCommitteeChairman(ids);
	};


	/**
	 * datepicker 手入力時のvalue整形
	 *
	 * @memberof Form
	 * @param value - 整形対象のvalue
	 * @return {string} - yyyy-mm-dd 形式の文字列
	 */
	formatForDatePicker(value) {
		console.log(`Form.formatForDatePicker / 整形前: ${value}`);

		// 特殊文字の置換
		value = value.replace(/ー/g, '-'); // 全角ハイフンを半角ハイフンに置換
		value = value.replace(/／/g, '-'); // 全角スラッシュを半角スラッシュに置換
		// 区切り文字を統一
		value = value.replace(/\//g, '-'); // スラッシュをハイフンに置換

		let year, month, day;

		if (value.match(/-/)) {
			let parts = value.split('-');
			if (parts.length !== 3) {
				throw new Error('Invalid date format');
			}
			year = parts[0];
			month = parts[1].length === 1 ? '0' + parts[1] : parts[1];
			day = parts[2].length === 1 ? '0' + parts[2] : parts[2];
		} else {
			const ymd = value.replace('-', '').replace('/', '');
			if (ymd.length !== 8) {
				throw new Error('Invalid date format');
			}
			year = ymd.slice(0, 4);
			month = ymd.slice(4, 6);
			day = ymd.slice(6, 8);
		}

		// yyyy-mm-dd形式の文字列を返す
		return `${year}-${month}-${day}`;
	};

	/**
 * datetimepicker 手入力時のvalue整形
 *
 * @memberof Form
 * @param value - 整形対象のvalue
 * @return {string} - yyyy-mm-dd 形式の文字列
 */
	formatForDatetimePicker(value) {
		console.log(`Form.formatForDatetimePicker / 整形前: ${value}`);

		// 特殊文字の置換
		value = value.replace(/ー/g, '-'); // 全角ハイフンを半角ハイフンに置換
		value = value.replace(/／/g, '-'); // 全角スラッシュを半角スラッシュに置換
		value = value.replace(/：/g, ':'); // 全角コロン
		// 区切り文字を統一
		value = value.replace(/\//g, '-'); // スラッシュをハイフンに置換

		let year, month, day;

		if (value.match(/-/)) {
			let parts = value.split('-');
			if (parts.length !== 3) {
				throw new Error('Invalid date format');
			}
			year = parts[0];
			month = parts[1].length === 1 ? '0' + parts[1] : parts[1];
			day = parts[2].length === 1 ? '0' + parts[2] : parts[2];
		} else {
			const ymd = value.replace('-', '').replace('/', '');
			if (ymd.length !== 8) {
				throw new Error('Invalid date format');
			}
			year = ymd.slice(0, 4);
			month = ymd.slice(4, 6);
			day = ymd.slice(6, 8);
		}

		// yyyy-mm-dd形式の文字列を返す
		return `${year}-${month}-${day}`;
	};

	/**
	 * 加盟員検索
	 *
	 * @memberof Form
	 * @param { [key: string]: number | null } queryParameters - クエリパラーメータ
	 * @return {undefined}
	 */
	searchMember(queryParameters) {
		console.log('Form.searchMember');
		this._model.searchMember(queryParameters);
	};


	/**
	 * 各画面共通の加盟員検索
	 *
	 * @memberof Form
	 * @param { [key: string]: number | null } queryParameters - クエリパラーメータ
	 * @return {undefined}
	 */
	commonSearchMember(queryParameters, endpoint) {
		console.log('Form.commonSearchMember');
		this._model.commonSearchMember(queryParameters, endpoint);
	};


	/**
	 * 加盟員検索モーダルで選択した人のデータ取得
	 *
	 * @memberof Form
	 * @param {number} userId - ユーザーID
	 * @return {undefined}
	 */
	getMemberDataFromMemberSearchModal(userId) {
		console.log('Form.getMemberDataFromMemberSearchModal');
		this._currentUserId = userId
		this._model.getMemberDataFromMemberSearchModal(userId);
	};


	/**
	 * 団IDから団委員長情報を取得
	 *
	 * @memberof Form
	 * @param {number} groupId - 団ID
	 * @return {undefined}
	 */
	getGroupCommitteeChairman(groupId) {
		console.log('Form.getGroupCommitteeChairman');
		this._model.getGroupCommitteeChairman(groupId);
	};


	/**
	 * 追加・非表示の操作が可能なマスタメンテナンスの更新
	 *
	 * @memberof Form
	 * @param {FormData} formData - フォームデータ
	 * @param {string} action - actionのURL
	 * @return {undefined}
	 */
	updateMasterMaintenance(formData, action) {
		console.log('Form.updateMasterMaintenance');
		this._model.updateMasterMaintenance(formData, action);
	};


	/**
	 * 日本連盟役務マスタメンテナンスの更新
	 *
	 * @memberof Form
	 * @param {FormData} formData - フォームデータ
	 * @return {undefined}
	 */
	updateMasterMaintenanceTitle(formData) {
		console.log('Form.updateMasterMaintenanceTitle');
		this._model.updateMasterMaintenanceTitle(formData);
	};


	/**
	 * サポーターを団に登録する画面で必要なデータをフェッチ
	 *
	 * @memberof Form
	 * @param groupId - 団ID
	 * @return {undefined}
	 */
	registerSupporter(groupId) {
		console.log('Form.registerSupporter');
		this._model.registerSupporter(groupId);
	};


	/**
	 * 手動で連盟セレクトボックスのonChangeを発火
	 *
	 * @memberof Form
	 * @param {FormData} formData - フォームデータ
	 * @return {undefined}
	 */
	dispatchChangeCouncilOnChange(formData) {
		console.log('Form.dispatchChangeCouncilOnChange');
		this._listener.trigger('dispatchChangeCouncilOnChange');
	};


	/**
	 * 寄附金支援先振り分け入力時の再計算
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	recalculateContributionPrice() {
		console.log('Form.recalculateContributionPrice')
		const $contributionPrices = $('.list-councils-to-contribute').find('.contribution_price')
		const isInvalid = Array.from($contributionPrices).some(element => $(element).hasClass('is-invalid'))
		if (isInvalid) {
			$('.total-contribution-price').hide()
			$('.total-contribution-price').closest('.form-group').find('.error-status').text(`支援先振り分け項目の入力に誤りがあります。`).removeClass('is-invalid text-danger')
			return
		}
		console.log('continue Form.recalculateContributionPrice')
		const baseContributionPrice = $('.base-contribution-price').data('base-contribution-price')
		const contributionPrices = Array.from($contributionPrices).map(element => Number($(element).val()) || 0)
		const total = Array.from(contributionPrices).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
		this.validateContributionPrice(baseContributionPrice, total)
	}


	/**
	 * 寄附金支援先振り分け金額のバリデーション
	 * 
	 * @memberof Form
	 * @param {number} baseContributionPrice 
	 * @param {number} total 
	 */
	validateContributionPrice(baseContributionPrice, total) {
		console.log('Form.validateContributionPrice')
		console.log(`baseContributionPrice: ${baseContributionPrice} / total: ${total}`)
		const $totalContributionPrice = $('.total-contribution-price')
		$totalContributionPrice.show().text(total.toLocaleString() + '円')
		const $errorStatus = $totalContributionPrice.closest('.form-group').find('.error-status')
		$errorStatus.text('')
		switch (true) {
			case (total < baseContributionPrice):
				console.log('total < baseContributionPrice')
				$errorStatus.text(`（${baseContributionPrice - total}円不足）`).addClass('is-invalid text-danger')
				break
			case (total == baseContributionPrice):
				console.log('total == baseContributionPrice')
				$errorStatus.text(`（±0円）`).removeClass('is-invalid text-danger')
				break
			case (baseContributionPrice < total):
				console.log('baseContributionPrice < total')
				$errorStatus.text(`（${total - baseContributionPrice}円超過）`).addClass('is-invalid text-danger')
				break
		}
	}


	/**
	 * multipart/form-data で送信
	 *
	 * @memberof Form
	 * @param {jQuery} $form
	 * @param {formData} formData
	 * @param {string | null} confirmationModalId
	 * @return {undefined}
	 */
	submitMultipartFormData($form, formData, confirmationModalId) {
		console.log('Form.submitMultipartFormData');
		this._model.submitMultipartFormData($form, formData, confirmationModalId);
	}


	/**
	 * ファイル出力
	 *
	 * @memberof Form
	 * @param {jQuery} $form
	 * @param {formData} formData
	 * @param {string} prefix
	 * @return {undefined}
	 */
	submitDataForOutputFiles($form, formData, prefix) {
		console.log('Form.submitDataForOutputFiles');
		this._model.submitDataForOutputFiles($form, formData, prefix);
	}


	/**
	 * 日本連盟内部メモ送信
	 *
	 * @memberof Form
	 * @param {formData} formData
	 * @return {undefined}
	 */
	updateInternalMemo(formData) {
		console.log('Form.updateInternalMemo');
		this._model.updateInternalMemo(formData);
	}

	/**
	 * 出納帳や組織画面のメモ送信
	 *
	 * @memberof Form
	 * @param {formData} formData
	 * @return {undefined}
	 */
	updateJapanCouncilNotes(formData) {
		console.log('Form.updateJapanCouncilNotes');
		this._model.updateJapanCouncilNotes(formData);
	}

	/**
	 * API TEST
	 *
	 * @memberof Form
	 * @param {string} code - コード
	 * @return {undefined}
	 */
	apiTest(code) {
		console.log('Form.apiTest');
		this._model.apiTest(code);
	};


	/**
	 * 掲示板HTML作成
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	createHtml(flg) {
		console.log('Form.createHtml');
		if (flg) {
			this._listener.trigger('onCreateDataSubmit');
		} else {
			this._listener.trigger('onCreateData');
		}
	};


	/**
	 * submit flg削除
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	deleteSubmit() {
		console.log('Form.deleteSubmit');
		this._listener.trigger('deleteSubmit');
	};


	/**
	 * 復活画面団削除
	 *
	 * @memberof Form
	 * @param {jQuery} $tr - テーブル行
	 * @return {undefined}
	 */
	blankGroup($tr) {
		console.log('Form.blankGroup');
		if ($tr.find('.council_id option:selected').attr('data-has-no-district') === 'true') {
			this._listener.trigger('blankGroupNoDistrict');
		} else {
			this._listener.trigger('blankGroupHasDistrict');
		}
	};


	/**
	 * 移籍対象者取得
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	getTransferTarget() {
		console.log('Form.getTransferTarget');
		this._model.getTransferTarget();
	};


	/**
	 * 銃登録対象者取得
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	getAdditionalTitleTarget() {
		console.log('Form.getAdditionalTitleTarget');
		this._model.getAdditionalTitleTarget();
	};


	/**
	 * お知らせ配信対象の再カウント
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	countSelectedCategorizedItems() {
		console.log('Form.countSelectedCategorizedItems');
		this._listener.trigger('countSelectedCategorizedItems');
	}


	/**
	 * お知らせ配信対象の全選択・解除の状態更新
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	updateToggleAllItemsInCategoryState() {
		console.log('Form.updateToggleAllItemsInCategoryState');
		this._listener.trigger('updateToggleAllItemsInCategoryState');
	}


	/**
	 * select2初期化
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	resetSelect2() {
		console.log('Form.getTransferTarget');
		this._listener.trigger('resetSelect2');
	};


	/**
	 * listener on
	 *
	 * @memberof Form
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn);
	};


	/**
	 * listener off
	 *
	 * @memberof Form
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn);
	};
}
